import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
	email: Yup.string()
		.matches(/^\S*$/, 'AUTH.VALIDATE.NO.WHITESPACE')
		.email('AUTH.VALIDATE.NO.VALID.EMAIL')
		.min(3, 'AUTH.VALIDATE.MIN.CARACTERS')
		.max(50, 'AUTH.VALIDATE.MAX.CARACTERS')
		.required('AUTH.VALIDATE.REQUIRED.EMAIL'),
	password: Yup.string()
		.min(3, 'AUTH.VALIDATE.MIN.CARACTERS')
		.max(50, 'AUTH.VALIDATE.MAX.CARACTERS')
		.required('AUTH.VALIDATE.REQUIRED.PASSWORD'),
});
